import { FC, useCallback, useMemo, useReducer } from 'react';
import { Dispatch, bindActionCreators } from 'redux';

import { BookCoworkingFromView } from './BookCoworkingFromView';
import * as bookCoworkingActions from './actions';
import {
  bookCoworkingFormReducer,
  getBookCoworkingFormInitialState,
  validationRules,
  validationRulesKeys,
} from './reducer';
import {
  IBookCoworkingFromProps,
  ICheckFormFieldInvalid,
  TBoundActions,
  TGetFormFieldErrorMessage,
  TGetFormFieldValue,
  TOnBlur,
  TOnSubmit,
} from './types';

export const BookCoworkingFrom: FC<IBookCoworkingFromProps> = props => {
  // Покрыто функ. тестами
  /* istanbul ignore next */
  const { onSubmit, formInitialState, disableFieldsOnPending = false, pending = false } = props;

  const [formState, formDispatch] = useReducer(
    bookCoworkingFormReducer,
    getBookCoworkingFormInitialState(formInitialState),
  );

  const boundActions = useMemo<TBoundActions>(
    () => bindActionCreators(bookCoworkingActions, formDispatch as Dispatch),
    [],
  );

  const handleSubmit = useCallback<TOnSubmit>(
    event => {
      event.preventDefault();

      const formValuesValid = !validationRulesKeys.some(key => {
        const validationRule = validationRules[key];

        return !!validationRule(formState[key].value, formState);
      });

      // Покрыто функ. тестами
      /* istanbul ignore next */
      if (formValuesValid) {
        onSubmit(formState);
      } else {
        // Покрыто функ. тестами
        /* istanbul ignore next */
        boundActions.validateAllAction();
      }
    },
    [formState, onSubmit, boundActions],
  );

  const handleBlur = useCallback<TOnBlur>(
    // Покрыто функ. тестами
    /* istanbul ignore next */
    fieldName => () => boundActions.validateByFieldAction(fieldName),
    [boundActions],
  );

  const getFormFieldErrorMessage = useCallback<TGetFormFieldErrorMessage>(
    fieldType => formState[fieldType].errorMessage,
    [formState],
  );

  const checkFormFieldInvalid = useCallback<ICheckFormFieldInvalid>(
    type => !!getFormFieldErrorMessage(type),
    [getFormFieldErrorMessage],
  );

  const getFormFieldValue = useCallback<TGetFormFieldValue>(fieldType => formState[fieldType].value, [formState]);

  return (
    <BookCoworkingFromView
      boundActions={boundActions}
      checkFormFieldInvalid={checkFormFieldInvalid}
      disableFieldsOnPending={disableFieldsOnPending}
      getFormFieldErrorMessage={getFormFieldErrorMessage}
      getFormFieldValue={getFormFieldValue}
      pending={pending}
      onBlur={handleBlur}
      onSubmit={handleSubmit}
    />
  );
};

BookCoworkingFrom.displayName = 'BookCoworkingFrom';
